// extracted by mini-css-extract-plugin
module.exports = {"ellipses":"Outs_ellipses__fEhNy"};